(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-instafeed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var overlay = document.getElementById('ss-lightbox-overlay');
    var overlayImg = document.getElementById('ss-lightbox-img');

    document.querySelectorAll('.ss-lightbox-label').forEach(function(el) {
      el.addEventListener('click', function() {
        overlayImg.src = el.getAttribute('data-lightbox-src');
        overlay.classList.add('is-open');
      });
    });

    overlay.addEventListener('click', function() {
      overlay.classList.remove('is-open');
      overlayImg.src = '';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
